/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */

'use strict';

module.exports = {
  DEFAULT_HANDLE_KEY: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/RelayDefaultHandleKey.js
// module id = 1014
// module chunks = 3